import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { NTA_COLORS, NTA_PAGE_PADDING_X } from '../../constants';
import { ntaHeaderTitleCss, ntaPageCss } from '../../typography';

export const HeaderRoot = styled.header`
  width: 100%;
  ${ntaPageCss}
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${NTA_COLORS.white};
  padding: 24px ${NTA_PAGE_PADDING_X};
  box-shadow: 0 16px 32px 0 ${NTA_COLORS.topBarShadow};

  ${mediaQuery.uptoMobile} {
    padding: 16px;
  }
`;

export const LogoImg = styled.img`
  height: 24px;
  width: 161px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;

  ${mediaQuery.uptoMobile} {
    width: 140px;
  }
`;

export const TopBarEnd = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
`;

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 98px;
  padding: 16px ${NTA_PAGE_PADDING_X};
  background: linear-gradient(
    180deg,
    ${NTA_COLORS.headerGradientStart} 0%,
    ${NTA_COLORS.headerGradientMid} 48.5%,
    ${NTA_COLORS.headerGradientEnd} 100%
  );

  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    min-height: 0;
    padding: 16px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  flex: 1;
  min-width: 0;
  color: ${NTA_COLORS.white};
  text-transform: uppercase;
  ${ntaHeaderTitleCss}

  ${mediaQuery.uptoMobile} {
    flex: none;
    width: 100%;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const TitleBarEnd = styled.div`
  flex-shrink: 0;

  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;
